import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AccessDeniedErrorPageComponent, GenericErrorPageComponent, NotFoundErrorPageComponent, ServerErrorPageComponent } from "@coso/layout-angular";
import { AuthGuardWithForcedLogin, LogoutComponent, TokenActivationComponent } from "@coso/saas-angular";
import { ReleaseNotesComponent } from "./release-notes/release-notes.component";
const routes: Routes = [
  {
    path: "",
    redirectTo: "configuration",
    pathMatch: "full"
  },
  { path: "release-notes", component: ReleaseNotesComponent },
  {
    path: "configuration",
    loadChildren: () => import("@coso-replicator/core").then((m) => m.ConfigurationModule),
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: "TokenActivation",
    component: TokenActivationComponent,
    canActivate: [AuthGuardWithForcedLogin]
  },
  { path: "logout", component: LogoutComponent },
  {
    path: "error",
    component: GenericErrorPageComponent,
    data: {
      contactUsHref: "https://portal.connecting-software.com/support/create-case/?subjectid=46802014-8f7f-e811-8106-3863bb35af60&cs_deploymenttype=768880001"
    }
  },
  { path: "404", component: NotFoundErrorPageComponent },
  { path: "401", component: AccessDeniedErrorPageComponent },
  {
    path: "500",
    component: ServerErrorPageComponent,
    data: {
      serviceName: "CB Replicator Service(s)",
      contactUsHref: "https://portal.connecting-software.com/support/create-case/?subjectid=46802014-8f7f-e811-8106-3863bb35af60&cs_deploymenttype=768880001"
    }
  },
  {
    path: "global-settings",
    loadChildren: () => import("@coso-replicator/core").then((m) => m.GlobalSettingsModule),
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: "**",
    redirectTo: "404",
    pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
